import {Component, EventEmitter, Input, Output, TemplateRef} from '@angular/core';
import {ReactiveFormsModule, UntypedFormGroup} from '@angular/forms';
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import {environment} from "../../../../environments/environment";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {NgSelectModule} from "@ng-select/ng-select";

@Component({
    selector: 'app-custom-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        NgSelectModule
    ]
})
export class SelectComponent {

    @Input() id: string;
    @Input() label = '';
    @Input() customFormGroup: UntypedFormGroup;
    @Input() noteText: string;
    @Input() placeholder = '';
    @Input() items: any[];
    @Input() bindLabel: string;
    @Input() customStringTemplate: TemplateRef<any>;
    @Input() bindValue: string;
    @Input() multiple = true;
    @Input() readonly = false;
    @Input() infoText: string;
    @Input() clearable = true;
    @Input() searchable = true;
    @Input() notfoundtext = "Nichts gefunden";
    @Input() loading = false;
    @Input() loadingText = "Lädt...";
    @Input() hideSelected = false;
    @Input() placeholderAlwaysVisible = false;
    @Input() infoTextBelowInput: string;

    @Output() onchange = new EventEmitter();
    @Output() onsearch = new EventEmitter();
    @Output() onScrollToEnd = new EventEmitter();
    @Output() ondelete = new EventEmitter<any[]>();
    @Output() onOpen = new EventEmitter();
    @Output() onClear = new EventEmitter();

    faInfo = faInfoCircle;

    isInvalid() {
        return (
            this.customFormGroup?.get(this.id)?.invalid &&
            this.customFormGroup?.get(this.id)?.touched
        );
    }

    triggerOnChange($event) {
        this.onchange.emit($event);
    }

    triggerSearch($event) {
        this.onsearch.emit($event);
    }

    triggerScrollToEnd($event) {
        this.onScrollToEnd.emit($event);
    }

    triggerOpen($event) {
        this.onOpen.emit($event);
    }

    triggerOnClear(){
      this.onClear.emit();
    }

    clearItem(item: any) {
        const index = this.items.indexOf(item);
        if (index > -1) {
            this.items.splice(index, 1)
        }
        this.ondelete.emit(this.items);
    }

    protected readonly environment = environment;
    protected readonly JSON = JSON;

  getDataType(item: any): string {
    if (item === null) return 'null' // typeof null returns "object" otherwise
    return (typeof item)
  }

  getTitle(): string{
    return this.label;
  }
}
